/************************************************************
 * Primitive Definitions
 */
const __SIZE__ = {
  s0: '0rem',
  s2: '0.125rem',
  s4: '0.25rem',
  s8: '0.5rem',
  s12: '0.75rem',
  s16: '1rem',
  s20: '1.25rem',
  s24: '1.5rem',
  s28: '1.75rem',
  s32: '2rem',
  s36: '2.25rem',
  s40: '2.5rem',
  s72: '4.5rem',
} as const

/************************************************************
 * Semantic Definitions
 */
const __SEMANTIC_SIZE__ = {
  column: __SIZE__.s12,
  gutter: __SIZE__.s24,
  marginMd: __SIZE__.s40,
  marginLg: __SIZE__.s72,
} as const

/************************************************************
 * Export
 */
export const SIZE = Object.freeze({
  ...__SIZE__,
  ...__SEMANTIC_SIZE__,
})
